
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts/[...permalink]",
      function () {
        return require("private-next-pages/podcasts/[...permalink].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcasts/[...permalink]"])
      });
    }
  